import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import cx from 'classnames';
import "./styles.scss";

const Button = ({
  size="lg",
  color='green',
  text,
  link=null,
  externalUrl=null,
  handleClick,
  state=null
}) => {
  if (!!link) {
    return (
      <Link to={link}
        className={cx("btn", {
          "btn-behivee-primary": color === 'green',
          "btn-gray": color === "gray",
          "btn-purple": color === "purple",
          "btn-sm": size === "sm",
          "btn-md": size === "md",
          "btn-lg": size === "lg",
          "btn-xl": size === "xl"
        })}
        state={state}
      >
      { text }
    </Link>
    )
  }

  if(!!externalUrl) {
    return (
      <a href={externalUrl} target="_blank" rel="noopener noreferrer"
         className={cx("btn", {
        "btn-behivee-primary": color === 'green',
        "btn-gray": color === "gray",
        "btn-purple": color === "purple",
        "btn-sm": size === "sm",
        "btn-md": size === "md",
        "btn-lg": size === "lg",
        "btn-xl": size === "xl"
      })}>{text}</a>
    )
  }

  return (
    <button
      onClick={handleClick}
      className={cx("btn", {
      "btn-behivee-primary": color === 'green',
      "btn-purple": color === "purple",
      "btn-sm": size === "sm",
      "btn-md": size === "md",
      "btn-lg": size === "lg",
      "btn-xl": size === "xl"
    })}>
      {text}
    </button>
  )
}

Button.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string.isRequired
}

Button.defaultProps = {
  color: 'green',
  size: 'sm',
}

export default Button;
